import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const SigningStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();

  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} color={'var(--mantine-color-grape-7)'} onClick={() => onClick('SIGNED_INCOMPLETE')} loading={isLoading}>
          {t('credit.status.action.SIGNED_INCOMPLETE')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} color={'var(--mantine-color-grape-7)'} onClick={() => onClick('SENT_TO_BANK')} loading={isLoading}>
          {t('credit.status.action.SIGNED_COMPLETED')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED')} loading={isLoading}>
          {t('credit.status.action.CANCELED')}
        </Button>
      </Box>
    </>
  )
}

export default SigningStatusActions;